/** @typedef {{ id: string, name: string, season: string, order: number, year?: number, startDate: string, endDate: string }} CalendarTerm */
/** @typedef {{ date: string, label: string }} CalendarClosure */

export const EMPTY_CALENDAR_CONFIG = {
  year: null,
  title: "",
  subtitle: "",
  intro: "",
  terms: [],
  closures: [],
};

/** @type {CalendarTerm[]} — used by unit tests only */
export const CALENDAR_TERMS_2026 = [
  {
    id: "spring-1",
    name: "Spring Term 1",
    season: "Spring",
    order: 1,
    year: 2026,
    startDate: "2026-01-05",
    endDate: "2026-02-01",
  },
  {
    id: "spring-2",
    name: "Spring Term 2",
    season: "Spring",
    order: 2,
    year: 2026,
    startDate: "2026-02-02",
    endDate: "2026-03-01",
  },
  {
    id: "spring-3",
    name: "Spring Term 3",
    season: "Spring",
    order: 3,
    year: 2026,
    startDate: "2026-03-02",
    endDate: "2026-03-29",
  },
  {
    id: "spring-4",
    name: "Spring Term 4",
    season: "Spring",
    order: 4,
    year: 2026,
    startDate: "2026-03-30",
    endDate: "2026-05-03",
  },
  {
    id: "spring-5",
    name: "Spring Term 5",
    season: "Spring",
    order: 5,
    year: 2026,
    startDate: "2026-05-04",
    endDate: "2026-05-31",
  },
  {
    id: "summer-1",
    name: "Summer Term 1",
    season: "Summer",
    order: 6,
    year: 2026,
    startDate: "2026-06-01",
    endDate: "2026-06-28",
  },
  {
    id: "summer-2",
    name: "Summer Term 2",
    season: "Summer",
    order: 7,
    year: 2026,
    startDate: "2026-06-29",
    endDate: "2026-08-02",
  },
  {
    id: "fall-1",
    name: "Fall Term 1",
    season: "Fall",
    order: 8,
    year: 2026,
    startDate: "2026-08-03",
    endDate: "2026-08-30",
  },
  {
    id: "fall-2",
    name: "Fall Term 2",
    season: "Fall",
    order: 9,
    year: 2026,
    startDate: "2026-08-31",
    endDate: "2026-09-27",
  },
  {
    id: "fall-3",
    name: "Fall Term 3",
    season: "Fall",
    order: 10,
    year: 2026,
    startDate: "2026-09-28",
    endDate: "2026-11-01",
  },
  {
    id: "fall-4",
    name: "Fall Term 4",
    season: "Fall",
    order: 11,
    year: 2026,
    startDate: "2026-11-02",
    endDate: "2026-11-29",
  },
  {
    id: "fall-5",
    name: "Fall Term 5",
    season: "Fall",
    order: 12,
    year: 2026,
    startDate: "2026-11-30",
    endDate: "2026-12-20",
  },
];

/** @deprecated Use EMPTY_CALENDAR_CONFIG in app code; this remains for tests. */
export const CALENDAR_DEFAULTS_2026 = {
  year: 2026,
  title: "ACE Calendar 2026",
  subtitle: "",
  intro: "",
  terms: CALENDAR_TERMS_2026,
  closures: [],
};
